@if (gallery() && galleryPermissions()) {
  <app-drop (onFileDrop)="uploadVersion($event)" [hoverStyle]="'replace'" [disable]="!galleryPermissions()?.can_edit">
    <div class="drop-holder"></div>
    @if (platformBrowser && activeAsset()) {
      <div
        class="all-container"
        [style.--color-primary]="gallery().primary_color"
        (mouseup)="mouseUp($event)"
        (mousemove)="mouseMove($event)"
      >
        <div
          class="section"
          [class.dark]="theme().asset_page.background_color === 'black'"
          [class.with-gradient]="activeAsset().type === 'image' || activeAsset().type === 'document'"
          (wheel)="onWheel($event)"
          [class.shrink]="!!sideMenuMode()"
          [class.drawing]="createAnnotation?.drawing || false"
          [class.show-top-gradient]="
            scale() > 0.9 &&
            (controlsVisible() || annotationMode) &&
            !mobileAnnotationViewingMode &&
            delayedControlsShow()
          "
          [class.show-bottom-gradient]="
            scale() > 0.9 &&
            (controlsVisible() || annotationMode) &&
            allowedAndEnabledFeedbackOptions().length &&
            !mobileAnnotationViewingMode &&
            delayedControlsShow()
          "
          [style.--background-opacity]="backgroundOpacity()"
          [class.animate-background-opacity]="animateOffset()"
        >
          <div
            class="section-background"
            [style.background-color]="theme().asset_page.background_color"
            [style.--asset-background-color]="theme().asset_page.background_color"
            [@sectionBackground]
            [@.disabled]="!assetTransitionMode()"
          ></div>
          @if (controlsVisible() && !annotationMode && !mobileAnnotationViewingMode && delayedControlsShow()) {
            <app-asset-header
              class="dont-hide-controls"
              [@assetHeader]
              [gallery]="gallery()"
              [galleryPermissions]="galleryPermissions()"
              [sideMenuOpen]="!!sideMenuMode() && isDesktop()"
              [asset]="activeAsset()"
              [thumbnailBarOpen]="showThumbnailBar()"
              [clientMode]="clientMode"
              [allowedAndEnabledFeedbackOptions]="allowedAndEnabledFeedbackOptions()"
              (onClose)="close()"
              (onThumbnailBarOpen)="toggleThumbnailBar($event)"
              (onShowInfo)="toggleSideMenu('info')"
              (onShowComments)="toggleSideMenu('activity')"
              [class.pdf-mode]="activeAsset().type === 'document'"
            >
            </app-asset-header>
          }

          @if (!isDesktop()) {
            @if (commentPlacementMode() === 'place') {
              <div class="mobile-info-box">Tap to Set Position</div>
            }
            @if (annotationMode && !createAnnotationShapes?.length) {
              <div class="mobile-info-box">Start Drawing</div>
            }
          }

          @if (newVersionUploadingOrProcessing()) {
            <div class="new-version-upload">
              <div>
                @if (
                  newVersionUploadProgress() === 0 || (newVersionUploadProgress() && newVersionUploadProgress() < 100)
                ) {
                  <app-circle-progress-bar
                    [progress]="newVersionUploadProgress()"
                    color="white"
                  ></app-circle-progress-bar>
                  <span>Uploading</span>
                } @else {
                  <app-loading-indicator color="white" size="small"></app-loading-indicator>
                  <span>Processing</span>
                }
              </div>
            </div>
          }

          @if (
            controlsVisible() &&
            (isDesktop() || activeAsset().type === 'document') &&
            (activeAsset() | canDisplayAsset) &&
            delayedControlsShow()
          ) {
            <div
              class="asset-viewer-controls-container dont-hide-controls"
              [@assetControls]
              [class.pdf-mode]="activeAsset().type === 'document'"
            >
              @if (activeAsset().type === 'image' || (activeAsset().type === 'document' && isDesktop())) {
                <app-image-viewer-controls
                  [scalePercent]="getScalePercent()"
                  (scale)="onScale($event, false)"
                  [fitButton]="fitButton()"
                >
                </app-image-viewer-controls>
              } @else if (activeAsset().type === 'video' || activeAsset().type === 'audio') {
                <app-video-viewer-controls [time]="videoTime" [type]="activeAsset().type"> </app-video-viewer-controls>
              } @else if (activeAsset().type === 'document' && !isDesktop()) {
                <app-document-viewer-controls
                  [(page)]="activePage"
                  [totalPages]="activeAsset().version_data.data?.['images']?.length"
                >
                </app-document-viewer-controls>
              }
            </div>
          }
          <ng-container *onlyForScreens="['desktop', 'tablet']">
            @if (controlsVisible() && !annotationMode && delayedControlsShow()) {
              <div
                class="arrow arrow-left dont-hide-controls"
                [class.disabled]="!previousAsset()"
                [class.pdf-mode]="activeAsset().type === 'document'"
                [@arrowLeft]
                (click)="switchAsset(-1).subscribe()"
              >
                <app-svg src="/assets/icons/special/arrow-left.svg"></app-svg>
              </div>
            }
          </ng-container>
          <div
            class="asset-viewer-container-parent"
            [class.pdf-mode]="activeAsset().type === 'document'"
            [class.animate-offset]="animateOffset()"
            [class.hidden]="assetTransitionMode()"
            (mousedown)="mouseDown($event)"
            (touchstart)="touchStart($event)"
            (touchend)="touchEnd($event)"
            (touchmove)="touchMove($event)"
          >
            @if (showWebGl()) {
              <app-image-viewer
                [class.hidden]="!showWebGl()"
                [asset]="activeAsset()"
                [offsetX]="offset().x"
                [offsetY]="offset().y"
                [scale]="scale()"
                [offsetScale]="offsetScale()"
                [sideMenuOpen]="!!sideMenuMode()"
                [isDesktop]="isDesktop()"
                [enabled]="showWebGl()"
              ></app-image-viewer>
            }
            @if (theme().asset_page.ambient_mode) {
              <app-asset-page-blur-hash [asset]="activeAsset()"></app-asset-page-blur-hash>
            }

            @for (asset of renderedAssets(); track asset.id) {
              @let isActive = asset.id === activeAsset().id;

              @let _offsetScale =
                isActive ? offsetScale() : (asset | offsetScale: windowWidth() : windowHeight() : !!sideMenuMode());
              @let _scale = isActive ? scale() : (asset | scale: _offsetScale);
              @let relativeIndex = $index - renderedAssetsActiveIndex();

              <app-asset-page-item
                [animateOffset]="animateOffset()"
                [style.left]="containerOffset() + 'px'"
                [style.left]="
                  isActive
                    ? containerOffset() + 'px'
                    : 'calc(' + (touchMode() === 'swipe' ? containerOffset() : 0) + 'px + ' + 100 * relativeIndex + '%)'
                "
                [asset]="asset"
                [offsetScale]="_offsetScale"
                [scale]="_scale"
                [crop]="
                  isActive
                    ? crop()
                    : (asset | crop: _scale : _offsetScale : windowWidth() : windowHeight() : !!sideMenuMode())
                "
                [offset]="isActive ? offset() : emptyRect"
                [gallery]="gallery()"
                [isActive]="isActive"
                [theme]="theme()"
                [isDesktop]="isDesktop()"
                [class.dragging]="isActive ? dragging() : undefined"
                [class.can-zoom]="isActive ? canZoom() : undefined"
                [class.place-comment-mode]="isActive ? commentPlacementMode() : undefined"
                [class.zoomed-in]="_scale > 1"
                [dragging]="isActive ? dragging() : undefined"
                [blockVideoClick]="isActive ? !!commentPlacementMode() : false"
                [sideMenuOpen]="!!sideMenuMode()"
                [controlsVisible]="controlsVisible() && delayedControlsShow()"
                [activePage]="isActive ? activePage() : 0"
                [commentPlacementMode]="isActive ? commentPlacementMode() : undefined"
                [verticalDragDelta]="isActive ? verticalDragDelta() : 0"
                [videoFocused]="isActive ? videoFocused() : false"
                [galleryPermissions]="galleryPermissions()"
                [isTeamMember]="isTeamMember()"
                [annotationMode]="annotationMode"
                [selectedThreadId]="selectedThreadId"
                [showResolved]="showResolved()"
                (activePageChange)="isActive && activePage.set($event); comments?.selectThread(undefined)"
                (onOffsetChange)="isActive && onOffsetChange($event)"
                (videoFocusedChange)="isActive && videoFocused.set($event)"
                (onTimeChange)="isActive && onTimeChange($event)"
                (selectThreadFromFace)="isActive && selectThreadFromFace($event)"
              ></app-asset-page-item>
            }
          </div>
          <ng-container *onlyForScreens="['desktop', 'tablet']">
            @if (controlsVisible() && !annotationMode && delayedControlsShow()) {
              <div
                class="arrow arrow-right dont-hide-controls"
                [@arrowRight]
                (click)="switchAsset(1).subscribe()"
                [class.disabled]="!nextAsset()"
                data-test-id="arrow-right"
              >
                <app-svg src="/assets/icons/special/arrow-right.svg"></app-svg>
              </div>
            }
          </ng-container>
          @if (activeAsset().type === 'document' && !isMobile()) {
            <app-pdf-page-list
              [version]="activeAsset().version_data"
              [asset]="activeAsset()"
              [gallery]="gallery()"
              [activePage]="activePage()"
              (switchPage)="activePage.set($event)"
            ></app-pdf-page-list>
          }
          @if (activeAsset().type === 'image') {
            <app-image-viewer-preview
              [class.disable-pointer-events]="commentPlacementMode()"
              [asset]="activeAsset()"
              [container]="containerSize()"
              [activePage]="activePage()"
              [showPreview]="scale() > 1 && controlsVisible() && delayedControlsShow()"
              [noAnimation]="!animateOffset()"
              [scale]="scale()"
              [offsetX]="offset().x"
              [offsetY]="offset().y"
              (onPreviewMove)="onPreviewMove($event)"
              *onlyForScreens="['desktop', 'tablet']"
            ></app-image-viewer-preview>
          }
          @if (showCreateCommentOverlay()) {
            <app-create-comment-overlay
              [gallery]="gallery()"
              [asset]="activeAsset()"
              [galleryPermissions]="galleryPermissions()"
              [isTeamMember]="isTeamMember()"
              [annotationMode]="annotationMode"
              [createAnnotationShapes]="createAnnotationShapes"
              [videoTime]="videoTime"
              [position]="createCommentOverlayPosition()"
              [activePage]="activePage()"
              [commentMessage]="commentMessage"
              [commentPlacePosition]="commentPlacePosition()"
              [commentPlaceAlignment]="commentPlaceAlignment()"
              [isDesktop]="isDesktop()"
              [offsetX]="offset().x"
              [offsetY]="offset().y"
              [scale]="scale()"
              [offsetScale]="offsetScale()"
              [sideMenuOpen]="!!sideMenuMode()"
              (toggleAnnotationMode)="toggleAnnotationMode()"
              (onNewThread)="onNewThread($event)"
              (customPosition)="commentPlacePosition.set($event)"
              (onClose)="createCommentOverlayClose()"
            ></app-create-comment-overlay>
          }
          @if (commentPlaceStartPosition() && commentPlaceHoverRect()) {
            <div
              class="overlay-drag-preview"
              [style.left]="commentPlaceHoverRect().x + 'px'"
              [style.top]="commentPlaceHoverRect().y + 'px'"
              [style.width]="commentPlaceHoverRect().width + 'px'"
              [style.height]="commentPlaceHoverRect().height + 'px'"
            ></div>
          }

          @if (
            galleryPermissions()?.can_review_if_authenticated &&
            (controlsVisible() || selectedThreadId) &&
            allowedAndEnabledFeedbackOptions().includes('comment') &&
            !annotationMode
          ) {
            @if (activeAsset().type !== 'video' || activeVideoEl()?.status() !== 'playing') {
              <app-asset-comment-faces
                [asset]="activeAsset()"
                [gallery]="gallery()"
                [isDesktop]="isDesktop()"
                [offsetX]="offset().x"
                [offsetY]="offset().y"
                [scale]="scale()"
                [offsetScale]="offsetScale()"
                [sideMenuOpen]="!!sideMenuMode()"
                [selectedThreadId]="selectedThreadId"
                [transitionPosition]="animateOffset()"
                [showResolved]="showResolved()"
                [hoverThreadId]="hoverThreadId"
                [containerOffset]="containerOffset()"
                [videoTime]="videoTime"
                [galleryPermissions]="galleryPermissions()"
                [isTeamMember]="isTeamMember()"
                [activePage]="activePage()"
                (selectThread)="selectThreadFromFace($event)"
                (threadHover)="hoverThreadId = $event?.id"
              ></app-asset-comment-faces>
            }
          }

          @if (annotationMode) {
            <app-create-annotation
              [offsetX]="offset().x"
              [offsetY]="offset().y"
              [scale]="scale()"
              [offsetScale]="offsetScale()"
              [sideMenuOpen]="!!sideMenuMode()"
              [isDesktop]="isDesktop()"
              [showAnnotationControls]="showAnnotationControls"
              [asset]="activeAsset()"
              [currentColor]="annotationColor"
              [currentTool]="annotationTool"
              [noAnimate]="!animateOffset()"
              (shapesChange)="annotationShapesChanges($event)"
              (annotationMouseDown)="annotationMouseDown()"
              (mousedown)="mouseDown($event)"
              (touchstart)="touchStart($event)"
              (touchend)="touchEnd($event)"
              (touchmove)="touchMove($event)"
              #createAnnotation
            >
            </app-create-annotation>
          }
          @if (annotationBeingViewed) {
            <app-view-annotation
              [shapes]="annotationBeingViewed.shapes"
              [sideMenuOpen]="!!sideMenuMode()"
              [hideClose]="!!sideMenuMode()"
              [isDesktop]="isDesktop()"
              [asset]="activeAsset()"
              [scale]="scale()"
              [offsetX]="offset().x"
              [offsetY]="offset().y"
              [offsetScale]="offsetScale()"
              [noAnimate]="!animateOffset()"
              [faded]="annotationMode"
              (onClose)="viewAnnotation(undefined)"
            >
            </app-view-annotation>
          }
          @if (controlsVisible() && !annotationMode && !mobileAnnotationViewingMode && delayedControlsShow()) {
            <div
              class="asset-footer dont-hide-controls"
              [class.pdf-mode]="activeAsset().type === 'document'"
              [@assetFooter]
            >
              <app-asset-page-footer
                [asset]="activeAsset()"
                [gallery]="gallery()"
                [galleryPermissions]="galleryPermissions()"
                [sideMenuOpen]="!!sideMenuMode() && isDesktop()"
                [currentLabel]="currentLabel()"
                [colorLabels]="colorLabels()"
                [commentPlacementMode]="!!commentPlacementMode()"
                [clientMode]="clientMode"
                (onToggleLike)="toggleLike()"
                (toggleCommentPlacementMode)="toggleCommentPlacementMode()"
                (onUpdateColorLabel)="updateColorLabel($event)"
                (onUpdateAssetStatus)="updateAssetStatus($event)"
                (onStartAnnotation)="startAnnotation()"
              >
              </app-asset-page-footer>
            </div>
          }
          @if (showAnnotationControls) {
            <app-annotation-controls
              [canUndo]="!!createAnnotation?.shapes.length"
              [canRedo]="!!createAnnotation?.deletedShapes.length"
              [isDesktop]="isDesktop()"
              (onSwitchTool)="annotationTool = $event"
              (onSwitchColor)="annotationColor = $event"
              (onHistoryChange)="createAnnotation.changeHistory($event)"
              (onClose)="annotationDone($event)"
              [@animationMode]
            >
            </app-annotation-controls>
          }
          @if (
            !controlsVisible() &&
            !annotationMode &&
            !mobileAnnotationViewingMode &&
            !(!isDesktop() && !!sideMenuMode()) &&
            (!commentPlacementMode() || isDesktop()) &&
            delayedControlsShow()
          ) {
            <app-asset-feedback-hints
              [@assetFeedbackHints]
              [asset]="activeAsset()"
              [is_liked]="activeAsset().is_liked"
              [likes]="activeAsset().likes"
              [status]="activeAsset().status"
              [color_label]="activeAsset().color_label"
              [gallery]="gallery()"
              [darkBackground]="true"
              [galleryPermissions]="galleryPermissions()"
            >
            </app-asset-feedback-hints>
          }
        </div>
        @if (!!sideMenuMode()) {
          <app-asset-side-menu
            [gallery]="gallery()"
            [asset]="activeAsset()"
            [clientMode]="clientMode"
            [mode]="sideMenuMode()"
            [thumbnailBarOpen]="showThumbnailBar()"
            [galleryPermissions]="galleryPermissions()"
            [allowedAndEnabledFeedbackOptions]="allowedAndEnabledFeedbackOptions()"
            [isDesktop]="isDesktop()"
            (onClose)="toggleSideMenu(null)"
            (onThumbnailBarOpen)="toggleThumbnailBar($event)"
            (onModeChange)="toggleSideMenu($event)"
          >
            @if (sideMenuMode() === 'activity') {
              <app-comments
                #comments
                [gallery]="gallery()"
                [asset]="activeAsset()"
                [allowedAndEnabledFeedbackOptions]="allowedAndEnabledFeedbackOptions()"
                [galleryPermissions]="galleryPermissions()"
                [isTeamMember]="isTeamMember()"
                [annotationMode]="annotationMode"
                [createAnnotationShapes]="createAnnotationShapes"
                [commentPlacementMode]="!!commentPlacementMode()"
                [videoTime]="videoTime"
                [isDesktop]="isDesktop()"
                [(activePage)]="activePage"
                [hideNewCommentThread]="createAnnotationShapes?.length > 1 || showCreateCommentOverlay()"
                [commentMessage]="commentMessage"
                [hoverThreadId]="hoverThreadId"
                [showResolved]="showResolved()"
                (viewAnnotation)="viewAnnotation($event)"
                (videoTimeChange)="videoTimeChangeWithoutAnnotation($event)"
                (toggleAnnotationMode)="toggleAnnotationMode()"
                (onNewThread)="onNewThread($event)"
                (selectedThreadChange)="selectedThreadId = $event"
                (placeComment)="switchPlaceComment($event)"
                (threadHover)="hoverThreadId = $event?.id"
                (zoomToComment)="zoomToComment($event)"
                (toggleShowResolved)="showResolved.set(!showResolved())"
              >
              </app-comments>
            }
            @if (sideMenuMode() === 'info') {
              <app-asset-info [gallery]="gallery()" [asset]="activeAsset()" [galleryPermissions]="galleryPermissions()">
              </app-asset-info>
            }
          </app-asset-side-menu>
        }
        @if (showThumbnailBar()) {
          <app-thumbnail-bar
            [gallery]="gallery()"
            [assets]="assetList()"
            [selectedAssetId]="activeAsset()?.id"
            (onSwitchToAsset)="onSwitchToAsset($event)"
            (onClose)="showThumbnailBar.set(false)"
            (loadMoreBefore)="fetchBeforeCount.set(fetchBeforeCount() + fetchBeforeIncrement)"
            (loadMoreAfter)="fetchAfterCount.set(fetchAfterCount() + fetchAfterIncrement)"
            [@thumbnailBar]
          >
          </app-thumbnail-bar>
        }
      </div>
    } @else {
      <div class="all-container">
        <div
          class="section"
          [style.background-color]="theme()?.asset_page.background_color"
          [class.dark]="theme()?.asset_page.background_color === 'black'"
        >
          <div class="section-background"></div>
        </div>
      </div>
    }
  </app-drop>
}

@if (longPressMode()) {
  <div class="long-press-messsage" [@longPressMessage]>
    @if (longPressMode() === 'release') {
      <app-svg src="/assets/icons/finger-tap.svg" size="0"></app-svg>
      <span>Release to Download</span>
    } @else if (longPressMode() === 'downloading') {
      <app-loading-indicator size="smaller" color="white"></app-loading-indicator>
      <span>Downloading...</span>
    } @else if (longPressMode() === 'done') {
      <app-svg src="/assets/icons/check.svg" size="0"></app-svg>
      <span>Completed</span>
    }
  </div>
}
